import React from 'react';
import SpecialsPage from './SpecialsPage';

export default function ShopNowPage() {
  return <SpecialsPage mode="shopnow" />;
}
